import React, { useContext, useState } from 'react';

const UserDataContext = React.createContext();
const UpdateUserDataContext = React.createContext();

export function useUserData() {
  return useContext(UserDataContext);
}

export function useUpdateUserData() {
  return useContext(UpdateUserDataContext);
}

export function UserDataContextProvider({ children }) {
  const [userData, setUserData] = useState();

  return (
    <UserDataContext.Provider value={userData}>
      <UpdateUserDataContext.Provider value={setUserData}>
        {children}
      </UpdateUserDataContext.Provider>
    </UserDataContext.Provider>
  );
}
